(function ($, $window, $body) {
	const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
	const mobileQuery = window.matchMedia('(max-width: 600px)');
	if (motionQuery.matches) {
		return;
	}

	const $hero = $(
		'.is-style-masked-hero, .is-style-masked-hero--landing, .is-style-cover-with-circles, .wp-block-media-text.is-style-circular',
	);
	if (!$hero.length) {
		return;
	}

	$hero.filter('.wp-block-media-text.is-style-circular').each(function () {
		const media = this.querySelector(
			'.wp-block-media-text__media img, .wp-block-media-text__media video',
		);
		if (!media) {
			return;
		}

		const fromVarX = media.style.getPropertyValue('--focal-x');
		const fromVarY = media.style.getPropertyValue('--focal-y');
		if (fromVarX && fromVarY) {
			this.style.setProperty('--focal-x', fromVarX);
			this.style.setProperty('--focal-y', fromVarY);
			return;
		}

		const inline = (media.getAttribute('style') || '').match(
			/object-position\s*:\s*([^;]+)/i,
		);
		const parts = (inline ? inline[1] : getComputedStyle(media).objectPosition)
			.trim()
			.split(/\s+/);
		this.style.setProperty('--focal-x', parts[0] || '50%');
		this.style.setProperty('--focal-y', parts[1] || '50%');
	});

	const $header = $('.main-header');

	// Parallax starts when the hero reaches the bottom of .main-header
	const updateParallax = () => {
		const scrollTop = $window.scrollTop();
		const windowHeight = $window.height();
		const headerHeight = $header.outerHeight() || 0;

		$hero.each(function () {
			const $currentHero = $(this);

			// Mobile circle: the wave-height travel finishes as the circle's bottom reaches the viewport top.
			if (mobileQuery.matches && this.classList.contains('is-style-circular')) {
				const media = this.querySelector('.wp-block-media-text__media');
				let progress = 1;
				if (media) {
					const $media = $(media);
					const circleBottom = $media.offset().top + $media.outerHeight();
					if (circleBottom > 0) {
						progress = Math.min(1, Math.max(0, scrollTop / circleBottom));
					}
				}
				const nextProgress = String(Math.round(progress * 1000) / 1000);
				if (this.style.getPropertyValue('--circular-scroll-progress') !== nextProgress) {
					this.style.setProperty('--circular-scroll-progress', nextProgress);
				}
			}

			const $anchor = $currentHero.closest('.wp-block-cover');
			const $ref = $anchor.length ? $anchor : $currentHero;
			const heroTop = $ref.offset().top;
			const heroHeight = $ref.outerHeight();

			const heroBottom = heroTop + heroHeight;
			if (heroBottom < scrollTop - windowHeight || heroTop > scrollTop + windowHeight + 200) {
				return;
			}

			let scrollDistance = 0;
			if (scrollTop + headerHeight >= heroTop) {
				scrollDistance = scrollTop + headerHeight - heroTop;
			}

			const newValue = `${scrollDistance}px`;
			const currentValue = $currentHero.css('--scroll-offset');
			if (currentValue !== newValue) {
				$currentHero.css({
					'--scroll-offset': newValue,
				});
			}
		});
	};

	// Throttle scroll events for better performance
	let ticking = false;
	const requestTick = () => {
		if (!ticking) {
			requestAnimationFrame(() => {
				updateParallax();
				ticking = false;
			});
			ticking = true;
		}
	};

	// Initial update
	updateParallax();

	// Update on scroll (throttled)
	$window.on('scroll', requestTick);

	// Update on resize
	$window.on('resize', updateParallax);

	function stopParallax() {
		$window.off('scroll', requestTick);
		$window.off('resize', updateParallax);
		$hero.css({
			'--scroll-offset': '0px',
			'--circular-scroll-progress': '0',
		});
	}

	if (typeof motionQuery.addEventListener === 'function') {
		motionQuery.addEventListener('change', function (event) {
			if (event.matches) {
				stopParallax();
			}
		});
	}
})(jQuery, jQuery(window), jQuery('body'));
